<app-textarea-field
  [label]="'LABEL.PAYMENT_INSTRUCTIONS' | translate"
  fieldId="payment_details_field"
  textareaE2eId="payment-details-field"
  toggleActionE2eId="payment-details-field-toggle-action"
  [placeholder]="'PLACEHOLDER.ENTER_PAYMENT_INSTRUCTIONS' | translate"
  [fieldControl]="formControl"
  [hideFieldIfNoInitialValue]="true"
  [fieldTriggerLabel]="'ACTION.ADD_PAYMENT_INSTRUCTIONS' | translate"
  (onBlur)="updatePaymentDetails()"
  [maxlength]="1000"
  [trackingObject]="trackingObject"
  [triggerTrackingAction]="triggerTrackingAction"
>
</app-textarea-field>
